import { render, staticRenderFns } from "./nakladnayaPeredacha.vue?vue&type=template&id=ffbae12a&scoped=true"
import script from "./nakladnayaPeredacha.vue?vue&type=script&lang=js"
export * from "./nakladnayaPeredacha.vue?vue&type=script&lang=js"
import style0 from "./nakladnayaPeredacha.vue?vue&type=style&index=0&id=ffbae12a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbae12a",
  null
  
)

export default component.exports